import { render, staticRenderFns } from "./UiDetail.vue?vue&type=template&id=6aed0051&scoped=true"
import script from "./UiDetail.vue?vue&type=script&lang=js"
export * from "./UiDetail.vue?vue&type=script&lang=js"
import style0 from "./UiDetail.vue?vue&type=style&index=0&id=6aed0051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed0051",
  null
  
)

export default component.exports